export const isInstrumentedExtensionFunction = (className: string | null, functionName: string) => {
    if (className) {
        if (className.startsWith('\\')) {
            className = className.slice(1)
        }
    }
    return instrumentedExtensionFunctions[`${className}::${functionName}`] || instrumentedExtensionFunctions[functionName]
}

const instrumentedExtensionFunctions = {
    fastcgi_finish_request: true,
    session_start: true,
    'PDO::__construct': true,
    'PDO::exec': true,
    'PDO::query': true,
    'PDO::commit': true,
    'PDOStatement::execute': true,
    curl_exec: true,
    curl_multi_remove_handle: true,
    curl_multi_add_handle: true,
    curl_multi_info_read: true,
    curl_multi_exec: true,
    curl_multi_close: true,
    curl_close: true,
    curl_setopt: true,
    curl_setopt_array: true,
    shell_exec: true,
    exec: true,
    system: true,
    passthru: true,
    proc_open: true,
    popen: true,
    proc_close: true,
    proc_terminate: true,
    pclose: true,
    'MongoDB\\Driver\\Manager::__construct': true,
    'MongoDB\\Driver\\Manager::executeCommand': true,
    'MongoDB\\Driver\\Manager::executeBulkWrite': true,
    'MongoDB\\Driver\\Manager::executeQuery': true,
    'MongoDB\\Driver\\Server::executeCommand': true,
    'MongoDB\\Driver\\Server::executeBulkWrite': true,
    'MongoDB\\Driver\\Server::executeQuery': true,
    'Memcache::set': true,
    'Memcache::get': true,
    'Memcache::replace': true,
    'Memcache::increment': true,
    'Memcache::decrement': true,
    apcu_add: true,
    apcu_cas: true,
    apcu_dec: true,
    apcu_delete: true,
    apcu_entry: true,
    apcu_exists: true,
    apcu_fetch: true,
    apcu_inc: true,
    apcu_store: true,
    'mysqli::__construct': true,
    'mysqli::real_connect': true,
    'mysqli::prepare': true,
    'mysqli::query': true,
    'mysqli::real_query': true,
    'mysqli_stmt::execute': true,
    mysqli_connect: true,
    mysqli_prepare: true,
    mysqli_query: true,
    mysqli_real_query: true,
    mysqli_execute: true,
    mysqli_stmt_execute: true,
    db2_connect: true,
    db2_pconnect: true,
    db2_prepare: true,
    db2_execute: true,
    db2_exec: true,
    oci_connect: true,
    oci_pconnect: true,
    oci_parse: true,
    oci_execute: true,
    oci_commit: true,
    'http\\Client::__construct': true,
    'http\\Client\\Request::__construct': true,
    'SoapClient::__doRequest': true,
    'Memcached::add': true,
    'Memcached::addByKey': true,
    'Memcached::append': true,
    'Memcached::appendByKey': true,
    'Memcached::cas': true,
    'Memcached::casByKey': true,
    'Memcached::decrement': true,
    'Memcached::decrementByKey': true,
    'Memcached::delete': true,
    'Memcached::deleteByKey': true,
    'Memcached::deleteMulti': true,
    'Memcached::deleteMultiByKey': true,
    'Memcached::fetch': true,
    'Memcached::fetchAll': true,
    'Memcached::flush': true,
    'Memcached::get': true,
    'Memcached::getAllKeys': true,
    'Memcached::getByKey': true,
    'Memcached::getDelayed': true,
    'Memcached::getDelayedByKey': true,
    'Memcached::getMulti': true,
    'Memcached::getMultiByKey': true,
    'Memcached::increment': true,
    'Memcached::incrementByKey': true,
    'Memcached::prepend': true,
    'Memcached::prependByKey': true,
    'Memcached::replace': true,
    'Memcached::replaceByKey': true,
    'Memcached::set': true,
    'Memcached::setByKey': true,
    'Memcached::setMulti': true,
    'Memcached::setMultiByKey': true,
    'Memcached::touch': true,
    'Memcached::touchByKey': true,
    chgrp: true,
    chmod: true,
    chown: true,
    copy: true,
    delete: true,
    disk_free_space: true,
    disk_total_space: true,
    file_exists: true,
    fileatime: true,
    filectime: true,
    filegroup: true,
    fileinode: true,
    filemtime: true,
    fileowner: true,
    fileperms: true,
    filesize: true,
    filetype: true,
    glob: true,
    is_dir: true,
    is_executable: true,
    is_file: true,
    is_link: true,
    is_readable: true,
    is_uploaded_file: true,
    is_writable: true,
    lchgrp: true,
    lchown: true,
    link: true,
    linkinfo: true,
    lstat: true,
    mkdir: true,
    move_uploaded_files: true,
    pathinfo: true,
    php_if_lstat: true,
    php_if_stat: true,
    readlink: true,
    rename: true,
    rmdir: true,
    stat: true,
    symlink: true,
    tmpfile: true,
    touch: true,
    unlink: true,
    file_get_contents: true,
    file_put_contents: true,
    fopen: true,
    flock: true,
    fwrite: true,
    fflush: true,
    fseek: true,
    fread: true,
    fgets: true,
    fgetss: true,
    fgetc: true,
    fgetcsv: true,
    ftell: true,
    feof: true,
    fpassthru: true,
    fputs: true,
    fputcsv: true,
    'AMQPExchange::publish': true,
    'AMQPChannel::startTransaction': true,
    'AMQPChannel::commitTransaction': true,
    'AMQPChannel::rollbackTransaction': true,
    'RedisCluster::append': true,
    'RedisCluster::bgrewriteaof': true,
    'RedisCluster::bgsave': true,
    'RedisCluster::bitcount': true,
    'RedisCluster::bitop': true,
    'RedisCluster::bitpos': true,
    'RedisCluster::blpop': true,
    'RedisCluster::brpop': true,
    'RedisCluster::brpoplpush': true,
    'RedisCluster::clearlasterror': true,
    'RedisCluster::client': true,
    'RedisCluster::close': true,
    'RedisCluster::cluster': true,
    'RedisCluster::command': true,
    'RedisCluster::config': true,
    'RedisCluster::dbsize': true,
    'RedisCluster::decr': true,
    'RedisCluster::decrby': true,
    'RedisCluster::del': true,
    'RedisCluster::discard': true,
    'RedisCluster::dump': true,
    'RedisCluster::echo': true,
    'RedisCluster::eval': true,
    'RedisCluster::evalsha': true,
    'RedisCluster::exec': true,
    'RedisCluster::exists': true,
    'RedisCluster::expire': true,
    'RedisCluster::expireat': true,
    'RedisCluster::flushall': true,
    'RedisCluster::flushdb': true,
    'RedisCluster::geoadd': true,
    'RedisCluster::geodist': true,
    'RedisCluster::geohash': true,
    'RedisCluster::geopos': true,
    'RedisCluster::georadius': true,
    'RedisCluster::georadiusbymember': true,
    'RedisCluster::get': true,
    'RedisCluster::getbit': true,
    'RedisCluster::getrange': true,
    'RedisCluster::getset': true,
    'RedisCluster::hdel': true,
    'RedisCluster::hexists': true,
    'RedisCluster::hget': true,
    'RedisCluster::hgetall': true,
    'RedisCluster::hincrby': true,
    'RedisCluster::hincrbyfloat': true,
    'RedisCluster::hkeys': true,
    'RedisCluster::hlen': true,
    'RedisCluster::hmget': true,
    'RedisCluster::hmset': true,
    'RedisCluster::hscan': true,
    'RedisCluster::hset': true,
    'RedisCluster::hsetnx': true,
    'RedisCluster::hstrlen': true,
    'RedisCluster::hvals': true,
    'RedisCluster::incr': true,
    'RedisCluster::incrby': true,
    'RedisCluster::incrbyfloat': true,
    'RedisCluster::info': true,
    'RedisCluster::keys': true,
    'RedisCluster::lastsave': true,
    'RedisCluster::lget': true,
    'RedisCluster::lindex': true,
    'RedisCluster::linsert': true,
    'RedisCluster::llen': true,
    'RedisCluster::lpop': true,
    'RedisCluster::lpush': true,
    'RedisCluster::lpushx': true,
    'RedisCluster::lrange': true,
    'RedisCluster::lrem': true,
    'RedisCluster::lset': true,
    'RedisCluster::ltrim': true,
    'RedisCluster::mget': true,
    'RedisCluster::mset': true,
    'RedisCluster::msetnx': true,
    'RedisCluster::multi': true,
    'RedisCluster::object': true,
    'RedisCluster::persist': true,
    'RedisCluster::pexpire': true,
    'RedisCluster::pexpireat': true,
    'RedisCluster::pfadd': true,
    'RedisCluster::pfcount': true,
    'RedisCluster::pfmerge': true,
    'RedisCluster::ping': true,
    'RedisCluster::psetex': true,
    'RedisCluster::psubscribe': true,
    'RedisCluster::pttl': true,
    'RedisCluster::publish': true,
    'RedisCluster::pubsub': true,
    'RedisCluster::punsubscribe': true,
    'RedisCluster::randomkey': true,
    'RedisCluster::rawcommand': true,
    'RedisCluster::rename': true,
    'RedisCluster::renamenx': true,
    'RedisCluster::restore': true,
    'RedisCluster::role': true,
    'RedisCluster::rpop': true,
    'RedisCluster::rpoplpush': true,
    'RedisCluster::rpush': true,
    'RedisCluster::rpushx': true,
    'RedisCluster::sadd': true,
    'RedisCluster::saddarray': true,
    'RedisCluster::save': true,
    'RedisCluster::scan': true,
    'RedisCluster::scard': true,
    'RedisCluster::script': true,
    'RedisCluster::sdiff': true,
    'RedisCluster::sdiffstore': true,
    'RedisCluster::set': true,
    'RedisCluster::setbit': true,
    'RedisCluster::setex': true,
    'RedisCluster::setnx': true,
    'RedisCluster::setoption': true,
    'RedisCluster::setrange': true,
    'RedisCluster::sinter': true,
    'RedisCluster::sinterstore': true,
    'RedisCluster::sismember': true,
    'RedisCluster::slowlog': true,
    'RedisCluster::smembers': true,
    'RedisCluster::smove': true,
    'RedisCluster::sort': true,
    'RedisCluster::spop': true,
    'RedisCluster::srandmember': true,
    'RedisCluster::srem': true,
    'RedisCluster::sscan': true,
    'RedisCluster::strlen': true,
    'RedisCluster::subscribe': true,
    'RedisCluster::sunion': true,
    'RedisCluster::sunionstore': true,
    'RedisCluster::time': true,
    'RedisCluster::ttl': true,
    'RedisCluster::type': true,
    'RedisCluster::unsubscribe': true,
    'RedisCluster::unlink': true,
    'RedisCluster::unwatch': true,
    'RedisCluster::watch': true,
    'RedisCluster::zadd': true,
    'RedisCluster::zcard': true,
    'RedisCluster::zcount': true,
    'RedisCluster::zincrby': true,
    'RedisCluster::zinterstore': true,
    'RedisCluster::zlexcount': true,
    'RedisCluster::zrange': true,
    'RedisCluster::zrangebylex': true,
    'RedisCluster::zrangebyscore': true,
    'RedisCluster::zrank': true,
    'RedisCluster::zrem': true,
    'RedisCluster::zremrangebylex': true,
    'RedisCluster::zremrangebyrank': true,
    'RedisCluster::zremrangebyscore': true,
    'RedisCluster::zrevrange': true,
    'RedisCluster::zrevrangebylex': true,
    'RedisCluster::zrevrangebyscore': true,
    'RedisCluster::zrevrank': true,
    'RedisCluster::zscan': true,
    'RedisCluster::zscore': true,
    'RedisCluster::zunionstore': true,
    'Redis::append': true,
    'Redis::auth': true,
    'Redis::bgSave': true,
    'Redis::bgrewriteaof': true,
    'Redis::bitcount': true,
    'Redis::bitop': true,
    'Redis::bitpos': true,
    'Redis::blPop': true,
    'Redis::brPop': true,
    'Redis::brpoplpush': true,
    'Redis::client': true,
    'Redis::close': true,
    'Redis::command': true,
    'Redis::config': true,
    'Redis::connect': true,
    'Redis::dbSize': true,
    'Redis::debug': true,
    'Redis::decr': true,
    'Redis::decrBy': true,
    'Redis::del': true,
    'Redis::delete': true,
    'Redis::discard': true,
    'Redis::dump': true,
    'Redis::echo': true,
    'Redis::eval': true,
    'Redis::evalsha': true,
    'Redis::exec': true,
    'Redis::exists': true,
    'Redis::expireAt': true,
    'Redis::flushAll': true,
    'Redis::flushDB': true,
    'Redis::geoadd': true,
    'Redis::geodist': true,
    'Redis::geohash': true,
    'Redis::geopos': true,
    'Redis::georadius': true,
    'Redis::georadiusbymember': true,
    'Redis::get': true,
    'Redis::getBit': true,
    'Redis::getMultiple': true,
    'Redis::getKeys': true,
    'Redis::getRange': true,
    'Redis::getSet': true,
    'Redis::getTimeout': true,
    'Redis::hDel': true,
    'Redis::hExists': true,
    'Redis::hGet': true,
    'Redis::hGetAll': true,
    'Redis::hIncrBy': true,
    'Redis::hIncrByFloat': true,
    'Redis::hKeys': true,
    'Redis::hLen': true,
    'Redis::hMget': true,
    'Redis::hMset': true,
    'Redis::hSet': true,
    'Redis::hSetNx': true,
    'Redis::hStrLen': true,
    'Redis::hVals': true,
    'Redis::hscan': true,
    'Redis::incr': true,
    'Redis::incrBy': true,
    'Redis::incrByFloat': true,
    'Redis::info': true,
    'Redis::isConnected': true,
    'Redis::keys': true,
    'Redis::lGet': true,
    'Redis::lGetRange': true,
    'Redis::lInsert': true,
    'Redis::lPop': true,
    'Redis::lPush': true,
    'Redis::lPushx': true,
    'Redis::lRemove': true,
    'Redis::lSet': true,
    'Redis::lSize': true,
    'Redis::lastSave': true,
    'Redis::listTrim': true,
    'Redis::migrate': true,
    'Redis::move': true,
    'Redis::mset': true,
    'Redis::mget': true,
    'Redis::msetnx': true,
    'Redis::multi': true,
    'Redis::object': true,
    'Redis::pconnect': true,
    'Redis::persist': true,
    'Redis::pexpire': true,
    'Redis::pexpireAt': true,
    'Redis::pfadd': true,
    'Redis::pfcount': true,
    'Redis::pfmerge': true,
    'Redis::ping': true,
    'Redis::pipeline': true,
    'Redis::psetex': true,
    'Redis::psubscribe': true,
    'Redis::pttl': true,
    'Redis::publish': true,
    'Redis::pubsub': true,
    'Redis::punsubscribe': true,
    'Redis::rPop': true,
    'Redis::rPush': true,
    'Redis::rPushx': true,
    'Redis::randomKey': true,
    'Redis::rawcommand': true,
    'Redis::renameKey': true,
    'Redis::renameNx': true,
    'Redis::restore': true,
    'Redis::role': true,
    'Redis::rpoplpush': true,
    'Redis::sAdd': true,
    'Redis::sAddArray': true,
    'Redis::sContains': true,
    'Redis::sDiff': true,
    'Redis::sDiffStore': true,
    'Redis::sInter': true,
    'Redis::sInterStore': true,
    'Redis::sMembers': true,
    'Redis::sMove': true,
    'Redis::sPop': true,
    'Redis::sRandMember': true,
    'Redis::sRemove': true,
    'Redis::sSize': true,
    'Redis::sUnion': true,
    'Redis::sUnionStore': true,
    'Redis::save': true,
    'Redis::scan': true,
    'Redis::script': true,
    'Redis::select': true,
    'Redis::set': true,
    'Redis::setBit': true,
    'Redis::setRange': true,
    'Redis::setTimeout': true,
    'Redis::setex': true,
    'Redis::setnx': true,
    'Redis::slaveof': true,
    'Redis::slowlog': true,
    'Redis::sort': true,
    'Redis::sortAsc': true,
    'Redis::sortAscAlpha': true,
    'Redis::sortDesc': true,
    'Redis::sortDescAlpha': true,
    'Redis::sscan': true,
    'Redis::strlen': true,
    'Redis::subscribe': true,
    'Redis::swapdb': true,
    'Redis::time': true,
    'Redis::ttl': true,
    'Redis::type': true,
    'Redis::unlink': true,
    'Redis::unsubscribe': true,
    'Redis::unwatch': true,
    'Redis::wait': true,
    'Redis::watch': true,
    'Redis::zAdd': true,
    'Redis::zCard': true,
    'Redis::zCount': true,
    'Redis::zDelete': true,
    'Redis::zDeleteRangeByRank': true,
    'Redis::zDeleteRangeByScore': true,
    'Redis::zIncrBy': true,
    'Redis::zInter': true,
    'Redis::zLexCount': true,
    'Redis::zRange': true,
    'Redis::zRangeByLex': true,
    'Redis::zRangeByScore': true,
    'Redis::zRank': true,
    'Redis::zRemRangeByLex': true,
    'Redis::zRevRange': true,
    'Redis::zRevRangeByLex': true,
    'Redis::zRevRangeByScore': true,
    'Redis::zRevRank': true,
    'Redis::zScore': true,
    'Redis::zUnion': true,
    'Redis::zscan': true,
    'Grpc\\Call::__construct': true,
    'Grpc\\Call::startBatch': true,
    'RdKafka\\Producer::__construct': true,
    'RdKafka::flush': true,
    'RdKafka::poll': true,
    'RdKafka\\Producer::flush': true,
    'RdKafka\\Producer::poll': true,
    'RdKafka\\Producer::initTransactions': true,
    'RdKafka\\Producer::commitTransaction': true,
    'RdKafka\\Producer::abortTransaction': true,
    'RdKafka\\ProducerTopic::produce': true,
    'RdKafka\\ProducerTopic::producev': true,
    spl_autoload_call: true,
    preg_match: true,
    preg_match_all: true,
    preg_split: true,
    preg_grep: true,
    preg_filter: true,
    preg_replace: true,
    preg_replace_callback: true,
    preg_replace_callback_array: true,
    'CakeEventManager::dispatch': true,
    'Cake\\Event\\EventManager::dispatch': true,
    'Controller::invokeAction': true,
    'Cake\\Controller\\Controller::invokeAction': true,
    'PHPUnit\\Framework\\TestCase::run': true,
    'wcf\\system\\request\\Request::handle': true,
    'wcf\\system\\request\\Request::execute': true,
    'wcf\\action\\AJAXProxyAction::invoke': true,
    'wcf\\acp\\action\\AJAXProxyAction::invoke': true,
    'wcf\\action\\AJAXInvokeAction::invoke': true,
    'wcf\\acp\\action\\AJAXInvokeAction::invoke': true,
    'wcf\\action\\BackgroundQueuePerformAction::execute': true,
    'wcf\\action\\CronjobPerformAction::handle': true,
    'wcf\\data\\cronjob\\CronjobAction::executeCronjobs': true,
    'wcf\\system\\template\\TemplateEngine::display': true,
    'wcf\\system\\template\\TemplateEngine::fetch': true,
    'wcf\\system\\background\\BackgroundQueueHandler::performJob': true,
    'oxShopControl::_process': true,
    'OxidEsales\\EshopCommunity\\Core\\ShopControl::_process': true,
    'Smarty::_smarty_include': true,
    'Smarty_Internal_Template::_subTemplateRender': true,
    'Smarty_Internal_TemplateCompilerBase::compile': true,
    'WP_Hook::do_action': true,
    'WP_Hook::apply_filters': true,
    'yii\\base\\Component::trigger': true,
    'CComponent::raiseEvent': true,
    'yii\\base\\View::renderFile': true,
    'CBaseController::renderFile': true,
    'yii\\base\\Event::trigger': true,
    'Twig\\Template::display': true,
    'Twig\\Template::render': true,
    'Twig\\Template::displayBlock': true,
    'Twig\\Environment::__construct': true,
    'Silex\\Application::run': true,
    'Spryker\\Shared\\Application\\Application::run': true,
    'Spryker\\Shared\\Application\\Application::boot': true,
    'Spryker\\Glue\\GlueApplication\\ApiApplication\\ApiApplicationProxy::run': true,
    'Spryker\\Glue\\GlueApplication\\ApiApplication\\ApiApplicationProxy::boot': true,
    'Symfony\\Component\\EventDispatcher\\EventDispatcher::dispatch': true,
    'Symfony\\Component\\EventDispatcher\\EventDispatcher::callListeners': true,
    'Symfony\\Component\\EventDispatcher\\EventDispatcher::doDispatch': true,
    'Symfony\\Component\\EventDispatcher\\Debug\\TraceableEventDispatcher::dispatch': true,
    'Symfony\\Component\\EventDispatcher\\Debug\\WrappedListener::__invoke': true,
    'Symfony\\Component\\HttpKernel\\Kernel::boot': true,
    'Symfony\\Component\\HttpKernel\\Event\\FilterControllerEvent::__construct': true,
    'Symfony\\Component\\HttpKernel\\Event\\ControllerEvent::__construct': true,
    'Symfony\\Component\\HttpKernel\\Kernel::terminate': true,
    'Symfony\\Component\\HttpKernel\\HttpKernel::terminate': true,
    'Shopware\\Core\\Kernel::boot': true,
    'Shopware\\Core\\Framework\\DataAbstractionLayer\\Dbal\\EntityReader::read': true,
    'Shopware\\Core\\Framework\\DataAbstractionLayer\\Write\\EntityWriter::upsert': true,
    'Shopware\\Core\\Framework\\DataAbstractionLayer\\Write\\EntityWriter::insert': true,
    'Shopware\\Core\\Framework\\DataAbstractionLayer\\Write\\EntityWriter::update': true,
    'Shopware\\Core\\Framework\\DataAbstractionLayer\\Write\\EntityWriter::delete': true,
    'Shopware\\Core\\Framework\\DataAbstractionLayer\\Write\\EntityWriter::write': true,
    'Shopware\\Core\\Framework\\DataAbstractionLayer\\Dbal\\EntitySearcher::search': true,
    'Shopware\\Elasticsearch\\Framework\\DataAbstractionLayer\\ElasticsearchEntitySearcher::search': true,
    'Shopware\\Core\\Framework\\DataAbstractionLayer\\EntityRepository::aggregate': true,
    'Shopware\\Core\\Framework\\DataAbstractionLayer\\EntityRepository::search': true,
    'Shopware\\Core\\Framework\\DataAbstractionLayer\\EntityRepository::searchIds': true,
    'Shopware\\Core\\Framework\\DataAbstractionLayer\\EntityRepository::update': true,
    'Shopware\\Core\\Framework\\DataAbstractionLayer\\EntityRepository::upsert': true,
    'Shopware\\Core\\Framework\\DataAbstractionLayer\\EntityRepository::create': true,
    'Shopware\\Core\\Framework\\DataAbstractionLayer\\EntityRepository::delete': true,
    'Shopware\\Core\\Content\\Category\\Service\\NavigationLoader::load': true,
    'Shopware\\Storefront\\Page\\Navigation\\NavigationPageLoader::load': true,
    'Shopware\\Storefront\\Page\\GenericPageLoader::load': true,
    'Shopware\\Storefront\\Pagelet\\Header\\HeaderPageletLoader::load': true,
    'Shopware\\Storefront\\Pagelet\\Footer\\FooterPageletLoader::load': true,
    'Shopware\\Core\\Content\\Category\\SalesChannel\\CachedNavigationRoute::loadNavigation': true,
    'Shopware\\Core\\Content\\Category\\SalesChannel\\CachedCategoryRoute::load': true,
    'Shopware\\Storefront\\Controller\\StorefrontController::renderStorefront': true,
    'Shopware\\Storefront\\Page\\Product\\ProductPageLoader::load': true,
    'Shopware\\Core\\Content\\Product\\SalesChannel\\Detail\\CachedProductDetailRoute::load': true,
    'Shopware\\Core\\Framework\\Event\\NestedEventDispatcher::dispatch': true,
    'Shopware\\Core\\Framework\\Event\\BusinessEventDispatcher::dispatch': true,
    'Shopware\\Core\\Framework\\Webhook\\WebhookDispatcher::dispatch': true,
    'Shopware\\Core\\Content\\Flow\\Dispatching\\FlowDispatcher::dispatch': true,
    'Enlight_Event_EventManager::notify': true,
    'Enlight_Event_EventManager::notifyUntil': true,
    'Enlight_Event_EventManager::filter': true,
    'Shopware\\Kernel::boot': true,
    'Shopware\\Kernel::buildContainer': true,
    'Shopware\\Kernel::dumpContainer': true,
    'JSMin::minify': true,
    'Less_Parser::getCss': true,
    'Shopware_Controllers_Backend_Cron::indexAction': true,
    'Shopware_Proxies_ShopwareControllersBackendCronProxy::indexAction': true,
    'Shopware\\Components\\Template\\HtmlMinCompressor::minify': true,
    'Illuminate\\Foundation\\Http\\Kernel::bootstrap': true,
    'Illuminate\\Session\\Middleware\\StartSession::startSession': true,
    'Illuminate\\Session\\Middleware\\StartSession::collectGarbage': true,
    'Illuminate\\View\\Engines\\CompilerEngine::get': true,
    'Illuminate\\View\\Engines\\PhpEngine::get': true,
    'Illuminate\\View\\Engines\\FileEngine::get': true,
    'Illuminate\\View\\Compilers\\BladeCompiler::compile': true,
    'Illuminate\\Events\\Dispatcher::dispatch': true,
    'Illuminate\\Events\\Dispatcher::fire': true,
    'Illuminate\\Database\\Eloquent\\Builder::getModels': true,
    'Illuminate\\Database\\Eloquent\\Model::save': true,
    'Illuminate\\Database\\Eloquent\\Model::delete': true,
    'Illuminate\\Database\\Eloquent\\Model::destroy': true,
    'Illuminate\\Support\\Facades\\Facade::__callStatic': true,
    'Neos\\Flow\\Http\\RequestHandler::boot': true,
    'Neos\\Fusion\\View\\FusionView::render': true,
    'Neos\\Flow\\Mvc\\View\\JsonView::render': true,
    'Neos\\Flow\\Mvc\\View\\SimpleTemplateView::render': true,
    'Mage_Core_Block_Abstract::toHtml': true,
    'Mage_Core_Model_App::_initModules': true,
    'Mage_Core_Model_Config::loadModules': true,
    'Mage_Core_Model_Config::loadDb': true,
    'Mage_Core_Model_App::dispatchEvent': true,
    'Credis_Client::__call': true,
    'Magento\\Framework\\View\\Element\\AbstractBlock::toHtml': true,
    'Magento\\Framework\\Event\\Manager::dispatch': true,
    'Magento\\Framework\\Event\\Invoker\\InvokerDefault::_callObserverMethod': true,
    'Magento\\Framework\\View\\Result\\Layout::renderResult': true,
    'Magento\\Framework\\App\\FrontController::dispatch': true,
    'Magento\\Backend\\App\\AbstractAction::dispatch': true,
    'Symfony\\Component\\HttpKernel\\Kernel::handle': true,
    'Symfony\\Component\\HttpKernel\\HttpKernel::handle': true,
    'SprykerShop\\Yves\\ShopApplication\\YvesBootstrap::boot': true,
    'SprykerShop\\Yves\\ShopApplication\\Bootstrap\\YvesBootstrap::boot': true,
    'Spryker\\Glue\\GlueApplication\\Bootstrap\\GlueBootstrap::boot': true,
    'Spryker\\Zed\\Console\\Communication\\ConsoleBootstrap::doRun': true,
    'Shopware\\Kernel::handle': true,
    'Shopware\\Components\\HttpCache\\Store::write': true,
    'Shopware\\Components\\HttpCache\\AppCache::handle': true,
    'Illuminate\\Foundation\\Http\\Kernel::handle': true,
    'Tideways\\LaravelOctane\\OctaneMiddleware::doHandle': true,
    'yii\\base\\Application::run': true,
    'CApplication::run': true,
    'Neos\\Flow\\Core\\Bootstrap::run': true,
    'Twig_Template::display': true,
    'Twig_Template::displayBlock': true,
    'Smarty::fetch': true,
    'Smarty_Internal_TemplateBase::fetch': true,
    'Smarty_Internal_TemplateBase::display': true,
    'Doctrine\\ORM\\Persisters\\BasicEntityPersister::load': true,
    'Doctrine\\ORM\\Persisters\\BasicEntityPersister::loadAll': true,
    'Doctrine\\ORM\\Persisters\\Entity\\BasicEntityPersister::load': true,
    'Doctrine\\ORM\\EntityManager::flush': true,
    'Doctrine\\ORM\\UnitOfWork::computeChangeSets': true,
    'Doctrine\\ORM\\UnitOfWork::dispatchOnFlushEvent': true,
    'Doctrine\\ORM\\UnitOfWork::dispatchPostFlushEvent': true,
    'Doctrine\\ORM\\UnitOfWork::executeInserts': true,
    'Doctrine\\ORM\\UnitOfWork::executeUpdates': true,
    'Doctrine\\ORM\\UnitOfWork::executeDeletions': true,
    'Doctrine\\ORM\\Query\\Parser::parse': true,
    'Doctrine\\ORM\\Internal\\Hydration\\AbstractHydrator::hydrateAll': true,
    'Doctrine\\ORM\\AbstractQuery::execute': true,
    'Propel\\Runtime\\ActiveQuery\\Criteria::doSelect': true,
    'Propel\\Runtime\\ActiveQuery\\Criteria::doInsert': true,
    'Propel\\Runtime\\ActiveQuery\\Criteria::doUpdate': true,
    'Propel\\Runtime\\ActiveQuery\\Criteria::doDelete': true,
    'Propel\\Runtime\\ActiveQuery\\Criteria::doCount': true,
    'GraphQL\\GraphQL::executeQuery': true,
    'GraphQL\\Executor\\Executor::resolveOrError': true,
    'GraphQL\\Language\\Parser::parse': true,
    'oxShopControl::start': true,
    'OxidEsales\\EshopCommunity\\Core\\ShopControl::start': true,
    'Mage::run': true,
    'Mage_Api2_Model_Server::run': true,
    'Magento\\Framework\\App\\Bootstrap::run': true,
    'Magento\\Framework\\App\\Bootstrap::create': true,
    'Magento\\Framework\\Interception\\Config\\Config::initialize': true,
    'Dispatcher::dispatch': true,
    'Cake\\Routing\\Dispatcher::dispatch': true,
    'Cake\\Http\\Server::run': true,
    'Predis\\Client::__call': true,
    'yii\\redis\\Connection::executeCommand': true,
    'Pheanstalk_Pheanstalk::put': true,
    'Pheanstalk\\Pheanstalk::put': true,
    'PhpAmqpLib\\Channel\\AMQPChannel::basic_publish': true,
    'Elasticsearch\\Client::performRequest': true,
    'Elasticsearch\\Endpoints\\AbstractEndpoint::performRequest': true,
    'OpenSearch\\Client::performRequest': true,
    'Elastic\\Elasticsearch\\Client::performRequest': true,
    'Elastic\\Elasticsearch\\Endpoints\\AbstractEndpoint::performRequest': true,
    'Zend_Controller_Action::dispatch': true,
    'Zend_Controller_Response_Abstract::setException': true,
    'Enlight_Controller_Response_ResponseHttp::setException': true,
    'Enlight_Controller_Action::dispatch': true,
    'Mage_Core_Controller_Varien_Action::dispatch': true,
    'Mage_Api_Model_Server::run': true,
    'Mage_Api2_Model_Resource::dispatch': true,
    'Mage::printException': true,
    'Error_Processor::process503': true,
    'yii\\base\\Module::runAction': true,
    'yii\\base\\ErrorHandler::handleException': true,
    'CController::run': true,
    'CApplication::handleException': true,
    'Illuminate\\Routing\\ControllerDispatcher::dispatch': true,
    'Illuminate\\Foundation\\Http\\Kernel::reportException': true,
    'Illuminate\\Foundation\\Exceptions\\Handler::render': true,
    'Symfony\\Component\\HttpKernel\\Controller\\ControllerResolver::getController': true,
    'Symfony\\Component\\HttpFoundation\\Response::send': true,
    'Shopware\\Core\\HttpKernel::handle': true,
    'Shopware\\Core\\Framework\\Adapter\\Kernel\\KernelFactory::create': true,
    'Shopware\\Storefront\\Framework\\Cache\\CacheStore::write': true,
    'Shopware\\Storefront\\Framework\\Cache\\Event\\HttpCacheHitEvent::__construct': true,
    'Shopware\\Core\\Framework\\Adapter\\Cache\\Http\\CacheStore::write': true,
    'Shopware\\Core\\Framework\\Adapter\\Cache\\Event\\HttpCacheHitEvent::__construct': true,
    'Symfony\\Component\\HttpKernel\\Controller\\ControllerResolver::createController': true,
    'Symfony\\Bundle\\FrameworkBundle\\Controller\\ControllerResolver::createController': true,
    'JMS\\DiExtraBundle\\HttpKernel\\ControllerResolver::createController': true,
    'Symfony\\Component\\Console\\Application::find': true,
    'Symfony\\Component\\Console\\Application::renderException': true,
    'Symfony\\Component\\Console\\Application::renderThrowable': true,
    'Symfony\\Component\\HttpKernel\\HttpKernel::handleException': true,
    'Symfony\\Component\\HttpKernel\\HttpKernel::handleThrowable': true,
    'oxView::setClassName': true,
    'OxidEsales\\EshopCommunity\\Core\\Controller\\BaseController::setClassKey': true,
    'oxShopControl::_handleBaseException': true,
    'OxidEsales\\EshopCommunity\\Core\\ShopControl::logException': true,
    'OxidEsales\\EshopCommunity\\Core\\Exception\\ExceptionHandler::handleUncaughtException': true,
    'ControllerCore::getController': true,
    'PrestaShopExceptionCore::displayMessage': true,
    'Drupal\\Core\\Controller\\ControllerResolver::createController': true,
    'Silex\\CallbackResolver::convertCallback': true,
    'Spryker\\Zed\\Kernel\\ControllerResolver\\ZedFragmentControllerResolver::getController': true,
    'Spryker\\Yves\\Kernel\\ControllerResolver\\YvesFragmentControllerResolver::getController': true,
    'Spryker\\Shared\\Router\\Resolver\\ControllerResolver::getController': true,
    'Spryker\\Glue\\GlueApplication\\Rest\\ControllerFilter::filter': true,
    'Spryker\\Zed\\Application\\Communication\\ZedBootstrap::boot': true,
    'Spryker\\Zed\\Application\\Communication\\BackofficeBootstrap::boot': true,
    'Spryker\\Zed\\Application\\Communication\\BackendApiBootstrap::boot': true,
    'Spryker\\Zed\\Application\\Communication\\BackendGatewayBootstrap::boot': true,
    'Spryker\\Shared\\ErrorHandler\\ErrorHandler::handleException': true,
    'Whoops\\Run::handleException': true,
    'Slim\\Route::__invoke': true,
    'Slim\\App::handleException': true,
    'Slim\\App::handlePhpError': true,
    'TYPO3\\CMS\\Extbase\\Mvc\\Controller\\ActionController::callActionMethod': true,
    'TYPO3\\CMS\\Error\\AbstractExceptionHandler::handleException': true,
    'Neos\\Flow\\Mvc\\Controller\\ActionController_Original::callActionMethod': true,
    'Neos\\Flow\\Error\\AbstractExceptionHandler::handleException': true,
    'TYPO3\\Flow\\Mvc\\Controller\\ActionController_Original::callActionMethod': true,
    'TYPO3\\Flow\\Error\\AbstractExceptionHandler::handleException': true,
    'Neos\\Flow\\Cli\\Request::setControllerCommandName': true,
    'ExceptionRenderer::__construct': true,
    'Cake\\Error\\ExceptionRenderer::__construct': true,
    'Laravel\\Lumen\\Application::handleFoundRoute': true,
    'Laravel\\Lumen\\Application::sendExceptionToHandler': true,
    'Magento\\Framework\\App\\Action\\Action::dispatch': true,
    'Magento\\Webapi\\Controller\\Rest\\Router\\Route::getServiceClass': true,
    'Magento\\GraphQl\\Controller\\GraphQl\\Interceptor::dispatch': true,
    'Magento\\Framework\\App\\Http::catchException': true,
    'Magento\\Framework\\GraphQl\\Exception\\ExceptionFormatter::create': true,
    'Magento\\Framework\\Webapi\\ErrorProcessor::maskException': true,
    'PHPUnit\\Framework\\TestSuite::run': true,
    'wcf\\system\\WCF::__construct': true,
    'wcf\\system\\WCF::handleException': true,
    'wcf\\system\\WCFACP::__construct': true,
    'wcf\\system\\CLIWCF::__construct': true,
}
